const defaultFormState = {
  number: '+1',
  assignedTo: '',
  company: '',
  type: '',
  userName: '',
  forwardUris: [],
  allowedUsers: [],
};

const numberFormState = (state = defaultFormState, action) => {
  let object = {};
  if (action.value === 'ringDown') {
    object = {
      ...state,
      forwardUris: [],
      [action.name]: action.value,
    };
  } else {
    object = {
      ...state,
      [action.name]: action.value
    };
  }

  switch (action.type) {
    case 'ADD_NUMBER_FIELD_CHANGE':
      return object;
    case 'ADD_NUMBER_SUCCESS':
    case 'ADD_NUMBER_CANCEL':
      return defaultFormState;
    default:
      return state;
  }
};

export default numberFormState;
